module.exports = __webpack_public_path__ + "static/media/MiniPI.c85961b6.png";